module.exports = __webpack_public_path__ + "img/gift-lucky.4fa101eb.png";